export function bodyLooksLikeHtml(text: string): boolean {
  const head = text.trimStart().slice(0, 64).toLowerCase();
  return (
    head.startsWith("<!doctype") ||
    head.startsWith("<html") ||
    head.startsWith("<head") ||
    head.startsWith("<body")
  );
}

export class NonJsonResponseError extends Error {
  readonly status: number;
  readonly statusText: string;
  constructor(message: string, status: number, statusText: string) {
    super(message);
    this.name = "NonJsonResponseError";
    this.status = status;
    this.statusText = statusText;
  }
}

export function parseJsonFromText(
  text: string,
  context: { status: number; statusText: string }
): unknown {
  const trimmed = text.trim();
  if (!trimmed) {
    if (context.status >= 200 && context.status < 300) {
      return {};
    }
    throw new NonJsonResponseError(
      "The server returned an empty response. Please try again.",
      context.status,
      context.statusText
    );
  }
  if (bodyLooksLikeHtml(trimmed)) {
    throw new NonJsonResponseError(
      "The server returned a web page instead of data. This usually means the API URL is wrong, the network returned an error page, or the browser used a stale cached response. Try a hard refresh (Ctrl+Shift+R or Cmd+Shift+R). If it keeps happening, clear site data for this app and sign in again.",
      context.status,
      context.statusText
    );
  }
  try {
    return JSON.parse(trimmed);
  } catch {
    throw new NonJsonResponseError(
      "The server response could not be read. Please try again.",
      context.status,
      context.statusText
    );
  }
}

export function readJsonFromResponse(response: Response): Promise<unknown> {
  return response.text().then((text) =>
    parseJsonFromText(text, {
      status: response.status,
      statusText: response.statusText,
    })
  );
}

export function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  return fetch(input, { ...init, cache: "no-store" });
}
